// Min and max of a numeric array by loop. `Math.min(...xs)` passes every
// element as a call argument and throws RangeError past the engine's
// argument ceiling (a 576k-point series did, PG-42). Empty input returns
// `Infinity`/`-Infinity`, the same sentinels as `Math.min()`/`Math.max()`.
export function minOf(xs: readonly number[]): number {
  let m = Infinity;
  for (const x of xs) if (x < m) m = x;
  return m;
}

export function maxOf(xs: readonly number[]): number {
  let m = -Infinity;
  for (const x of xs) if (x > m) m = x;
  return m;
}
